import { isEmpty } from "lodash"
import {imagePath, sitename} from "constants/constants"
import get from "lodash/get"
import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Input,
  CardImg,
  CardSubtitle,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { formValidation, mapDataForDropDown } from "helpers/helpers"
import Dropzone from "react-dropzone"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"
// Form Editor
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError, removeError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import { updatePromotion } from "store/Marketing/actions"
import { getAllPromotionsCall } from "../../../helpers/repository"
const Edit = props => {
  const dispatch = useDispatch()
  const [start_date, set_start_date] = useState("")
  const [end_date, set_end_date] = useState("")
  const [banner, set_banner] = useState({})
  const [promotion_type, set_promotion_type] = useState({
    label: "",
    value: "",
  })
  const [header, set_header] = useState("")
  const [short_body, set_short_body] = useState("")
  const [description, set_description] = useState("")
  const [status, set_status] = useState(false)

  function handleAcceptedFiles(files) {
    removeError("banner")
    files.map(file => {
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file?.size),
      })
      set_banner(file)
    })
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  useEffect(() => {
    getDefaultState()
    dispatch(apiError(""))
  }, [])
  const urlParams = new URLSearchParams(props.location.search)

  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      start_date: start_date,
      end_date: end_date,
      image: banner,
      promotion_type: promotion_type?.label,
      header: header,
      short_body: short_body,
      description: description,
      status: status ? 1 : 0,
    }
    if (banner instanceof File == false) {
      delete data["image"]
    }
    let form_data = new FormData()

    for (let key in data) {
      form_data.append(key, data[key])
    }

    dispatch(updatePromotion(form_data, props.history, +urlParams.get("id")))
  }

  const formErrors = useSelector(state => state?.CommonState)

  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }
  const getDefaultState = () => {
    getAllPromotionsCall().then(res => {
      let obj = res.data.data.filter(mr => mr["id"] == urlParams.get("id"))

      obj = obj.length > 0 ? obj[0] : {}
      set_start_date(obj.start_date)
      set_end_date(obj.end_date)
      set_banner({
        name: obj["banner"],
        preview: obj["banner"],
      })
      set_promotion_type({
        label: obj.promotion_type,
        value: obj.promotion_type,
      })
      set_header(obj.header)
      set_short_body(obj.short_body)
      set_description(obj.description)
      set_status(obj.status)
    })
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Bonuses" breadcrumbItem="Create" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              Create Promotion
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Start Date
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="date"
                      onChange={e => {
                        removeError("start_date")
                        set_start_date(e.target.value)
                      }}
                      value={start_date}
                    />
                    {formErrors?.start_date ? (
                      <FieldValidation errorMessage={formErrors?.start_date} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    End Date
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="date"
                      onChange={e => {
                        removeError("end_date")
                        set_end_date(e.target.value)
                      }}
                      value={end_date}
                    />
                    {formErrors?.end_date ? (
                      <FieldValidation errorMessage={formErrors?.end_date} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Banner
                  </Label>
                  <Col sm={5}>
                    {isEmpty(banner) ? (
                      <Dropzone
                        onDrop={acceptedFiles => {
                          handleAcceptedFiles(acceptedFiles)
                        }}
                        multiple={false}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="dropzone">
                            <div
                              className="dz-message needsclick mt-2"
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div className="mb-3">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                              </div>
                              <h4>Drop files here or click to upload.</h4>
                              <em style={{ fontSize: "12px", color: "red" }}>
                                (Only *.svg and *.png images will be accepted)
                              </em>
                              <br></br>
                              <em style={{ fontSize: "10px", color: "red" }}>
                                (Banner Dimension should be 770x150)
                              </em>
                            </div>
                          </div>
                        )}
                      </Dropzone>
                    ) : (
                      <>
                        <div className="dropzone">
                          <>
                            <div className="promotions-banner-title p-1">
                              <CardTitle>Promotions Banner</CardTitle>
                              <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => {
                                  set_banner({})
                                }}
                              ></button>
                            </div>
                            <CardImg
                              data-dz-thumbnail=""
                              height="80"
                              alt={banner.name}
                              src={
                                [undefined].includes(banner.formattedSize)
                                  ? imagePath("banners", banner.preview)
                                  : banner.preview
                              }
                              className="img-fluid p-1 dropzone-img"
                              id="imageid"
                            />
                          </>
                        </div>
                      </>
                    )}

                    {formErrors?.image?.length >= 0 ? (
                      <FieldValidation errorMessage={formErrors?.image[0]} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Promotion Type
                  </Label>
                  <Col sm={5}>
                    <Select
                      maxMenuHeight={150}
                      onChange={promotion => {
                        removeError("promotion_type")
                        set_promotion_type(promotion)
                      }}
                      options={[
                        {
                          value: "Loyalty Promo",
                          label: "Loyalty Promo",
                        },
                        {
                          value: "Stake Back",
                          label: "Stake Back",
                        },
                        {
                          value: "Multibet Booster",
                          label: "Multibet Booster",
                        },
                        {
                          value: "Cashout",
                          label: "Cashout",
                        },
                        {
                          value: "Sign Up Bonus",
                          label: "Sign Up Bonus",
                        },
                        {
                          value: "Deposit Bonus",
                          label: "Deposit Bonus",
                        },
                        {
                          value: "Refer A Friend",
                          label: "Refer A Friend",
                        },
                      ]}
                      classNamePrefix="select2-selection"
                      value={{
                        label: promotion_type.label,
                        value: promotion_type.value,
                      }}
                    />
                    {formErrors?.promotion_type ? (
                      <FieldValidation
                        errorMessage={formErrors?.promotion_type}
                      />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Blurb Header
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="text"
                      maxLength="40"
                      name="blurbHeader"
                      onChange={e => {
                        removeError("header")
                        set_header(e.target.value)
                      }}
                      value={header}
                    />
                    {formErrors?.header ? (
                      <FieldValidation errorMessage={formErrors?.header} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Blurb Short Body
                  </Label>
                  <Col sm={5}>
                    <textarea
                      className="form-control"
                      id="subject"
                      rows="5"
                      maxLength="124"
                      name="blurbShortBody"
                      onChange={e => {
                        removeError("short_body")
                        set_short_body(e.target.value)
                      }}
                      value={short_body}
                    />
                    {formErrors?.short_body ? (
                      <FieldValidation errorMessage={formErrors?.short_body} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Description
                  </Label>
                  <Col sm={5}>
                    <CKEditor
                      editor={ClassicEditor}
                      data={description}
                      onReady={editor => {
                        // You can store the "editor" and use when it is needed.
                      }}
                      onChange={(event, editor) => {
                        removeError("description")
                        const data = editor.getData()
                        set_description(data)
                      }}
                      // value={description}
                    />
                    {formErrors?.description ? (
                      <FieldValidation errorMessage={formErrors?.description} />
                    ) : null}
                  </Col>
                </div>
                <div className="d-flex flex-wrap gap-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="defaultCheck1"
                      onChange={() => set_status(!status)}
                      defaultChecked={status}
                    />
                    <label className="form-check-label" htmlFor="defaultCheck1">
                      Status
                    </label>
                  </div>
                </div>
                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/crm/marketing")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const EditPromotion = withRouter(Edit)
